import * as React from 'react';
import { DataGrid, GridToolbarExport,
GridToolbarContainer } from '@mui/x-data-grid';
import Breadcrumb from '../Components/Breadcrumb';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import './Agentdashboard.css';
import './Agentsalesreport.css';

const columns = [
{ field: 'id', headerName: 'No', width: 95 },
{ field: 'bill', headerName: 'BillNo', width: 140 },
{ field: 'date', headerName: 'DOS', width: 140 },
{ field: 'customer', headerName: 'Customer', width: 140 },
{ field: 'contact', headerName: 'ContactNumber', width: 140 },
{ field: 'product', headerName: 'Product', width: 140 },
{ field: 'qty', headerName: 'Qty', width: 140 },
{ field: 'payamount', headerName: 'PayAmount', width: 140 },
{ field: 'address', headerName: 'Address', width: 140 },
]

const rows = [
{ id: 1, bill:"A220016",date:"29/Apr/2022", customer: "Sukumar", contact:"8923561452", product:"Indian anchovy", qty:"2.00", payamount:"250.00", address:"Sukumar bhavan,near plaza" },
{ id: 2, bill:"A220016",date:"29/Apr/2022", customer: "Sukumar", contact:"8923561452", product:"Indian anchovy", qty:"2.00", payamount:"250.00", address:"Sukumar bhavan,near plaza" },
{ id: 3, bill:"A220016",date:"29/Apr/2022", customer: "Sukumar", contact:"8923561452", product:"Indian anchovy", qty:"2.00", payamount:"250.00", address:"Sukumar bhavan,near plaza" },
{ id: 4, bill:"A220016",date:"29/Apr/2022", customer: "Sukumar", contact:"8923561452", product:"Indian anchovy", qty:"2.00", payamount:"250.00", address:"Sukumar bhavan,near plaza" },
{ id: 5, bill:"A220016",date:"29/Apr/2022", customer: "Sukumar", contact:"8923561452", product:"Indian anchovy", qty:"2.00", payamount:"250.00", address:"Sukumar bhavan,near plaza" },
{ id: 6, bill:"A220016",date:"29/Apr/2022", customer: "Sukumar", contact:"8923561452", product:"Indian anchovy", qty:"2.00", payamount:"250.00", address:"Sukumar bhavan,near plaza" },
{ id: 7, bill:"A220016",date:"29/Apr/2022", customer: "Sukumar", contact:"8923561452", product:"Indian anchovy", qty:"2.00", payamount:"250.00", address:"Sukumar bhavan,near plaza" },
{ id: 8, bill:"A220016",date:"29/Apr/2022", customer: "Sukumar", contact:"8923561452", product:"Indian anchovy", qty:"2.00", payamount:"250.00", address:"Sukumar bhavan,near plaza" },
{ id: 9, bill:"A220016",date:"29/Apr/2022", customer: "Sukumar", contact:"8923561452", product:"Indian anchovy", qty:"2.00", payamount:"250.00", address:"Sukumar bhavan,near plaza" },
{ id: 10, bill:"A220016",date:"29/Apr/2022", customer: "Sukumar", contact:"8923561452", product:"Indian anchovy", qty:"2.00", payamount:"250.00", address:"Sukumar bhavan,near plaza" },

];

function MyExportButton() {
return (
	<GridToolbarContainer>
	<GridToolbarExport />
	</GridToolbarContainer>
);
}

export default function App() {
	const USR_TYPE = localStorage.getItem("userType")
	const [value, setValue] = React.useState(new Date());
	//console.log(USR_TYPE)
if( USR_TYPE === 'agent')
return (<div>
	<Breadcrumb head="Agent Dashboard"/>
		<div className="container-fluid">
			<div className="date-picker res-date-picker">
				<LocalizationProvider dateAdapter={AdapterDateFns}>
					<DatePicker
      					label="Select Date"
      					value={value}
      					inputFormat="dd MMM yyyy"
      					onChange={(e) => {
        				console.log(e);
        				setValue(e);
     					 }}
      					renderInput={(params) => <TextField {...params} fullWidth />}
    				/>
    			</LocalizationProvider>
			</div>
		</div>
		<div className="container">
			<h4 className="mb-2">My Dashboard</h4>
			<div className="row mb-3">
				<div className="dashboard">
					<div className="card">
						<h3 className="mb-2">0</h3>
						<p>Today's Sales</p>
					</div>
				</div>
				<div className="dashboard">
					<div className="card">
						<h3 className="mb-2">0</h3>
						<p>Today's Sale Amount</p>
					</div>
				</div>
				<div className="dashboard">
					<div className="card">
						<h3 className="mb-2">0</h3>
						<p>Today's Earnings</p>
					</div>
				</div>
			</div>
			<div className="mb-5 " style={{ height: 400, width: '100%' }}>
				<h4 className="mb-2">Sales Report</h4>
				<DataGrid rows={rows} columns={columns}
					pageSize={50}
					components={{
					Toolbar: MyExportButton,
					}}
				/>
			</div>
		</div>
</div>
)
else 
return ""
}
